import _ from 'lodash';
import globalStore from '$$globalStore';
import ganttViewModel from '$$ganttViewModel';

export default function(ganttId = null) {
  const activeViewData = ganttViewModel.getActiveViewData();
  let viewGanttIDs = activeViewData ? (activeViewData.ganttIDs || [activeViewData.gantt_id]) : [];
  let resources = [];

  if (ganttId) {
    viewGanttIDs = [ganttId];
  }

  for (const ganttID of viewGanttIDs) {
    const resourcesByGanttID = globalStore.getters['resourcesModel/getResourcesByProjectIdForUI'](ganttID);

    resources = _.unionBy(resources, resourcesByGanttID, 'id');
  }

  return resources;
}
